import clsx from 'clsx';
import { graphql, useStaticQuery } from 'gatsby';
import { useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import { trackEventUniversal } from 'helpers';

import { CTA } from './CTA_Wrapper';
import { Body } from './Typography';
import { Button } from './rebrand/Button';
import { LocaleContext } from './rebrand/Layout';

const CTA_BudgetTemplate = ({ className }: { className?: string }) => {
  const locale = useContext(LocaleContext);
  const { img } = useStaticQuery(graphql`
    query {
      img: file(relativePath: { eq: "misc/Budget.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, width: 688, quality: 100)
        }
      }
    }
  `);

  const copy = {
    imgAltText: {
      ctaBudgetTemplate: {
        en: `Learn to Save Money`,
        fr: `Apprenez a économiser.`,
      }[locale],
    },
  };

  return (
    <CTA
      image={img.childImageSharp.gatsbyImageData}
      imgAltText={copy.imgAltText.ctaBudgetTemplate}
      title={
        {
          en: `Get your personal budget template!`,
          fr: `Téléchargez votre modèle de budget personnel!`,
        }[locale]
      }
      className={twMerge(clsx('mb-64', className))}
    >
      <Body>
        {
          {
            en: `See where your money is going and how much you can save.`,
            fr: `Voyez où va votre argent et combien vous pouvez épargner.`,
          }[locale]
        }
      </Body>
      <a
        href={
          {
            en: '/personal-budget-template-en.xlsx',
            fr: '/personal-budget-template-fr.xlsx',
          }[locale]
        }
        download={{ en: 'personal-budget-template-en.xlsx', fr: 'personal-budget-template-fr.xlsx' }[locale]}
        onClick={() =>
          trackEventUniversal('Personal Budget Template Clicked', {
            event_category: 'tracking',
            event_label: 'budget-template',
          })
        }
      >
        <Button>{{ en: `Get it now`, fr: `Télécharger` }[locale]}</Button>
      </a>
    </CTA>
  );
};

export default CTA_BudgetTemplate;
